import React from 'react';

/**
 * Pill button matching the ClientBloom brand. Replaces the old `.purple-button`
 * and scattered `sx={{ bgcolor: '#572AF1' }}` MUI buttons.
 *
 * variant: 'primary' | 'ghost' | 'danger'
 */
const VARIANTS = {
  primary: 'cb-btn-primary',
  ghost: 'cb-btn-ghost',
  danger: 'cb-btn-danger',
};

const Button = React.forwardRef(function Button(
  { variant = 'primary', type = 'button', className = '', children, ...props },
  ref
) {
  const variantClass = VARIANTS[variant] || VARIANTS.primary;
  return (
    <button ref={ref} type={type} className={`${variantClass} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
});

export default Button;
